import React from 'react';
//import './Modal.css'; // Create styles for your modal if needed

const EditUserModal = ({ user, onClose, onUserUpdated }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit User</h2>
        <p>Edit user details for {user.firstName} {user.lastName}</p>
        {/* Your form elements here */}
        <button onClick={onUserUpdated}>Save Changes</button>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default EditUserModal;
